<template>
  <div>
    <highcharts :options="BarChart()"></highcharts>
  </div>
</template>

<script>
import Highcharts from "highcharts";
export default {
  props: ["title", "data"],
  methods: {
    BarChart() {
      console.log(this.data);
      let x = [];
      let allnum = [];
      this.data.data[0].data.map((xy) => {
        x.push({
          name: xy.name,
          data: [xy.y],
        });
        allnum.push(xy.y);
      });
      let dataSum = 0;
      for (var i = 0; i < allnum.length; i++) {
        dataSum += allnum[i];
      }
      let chart = {
        chart: {
          type: "column",
          style: {
            fontFamily: "Mitr",
          },
        },
        colors:
          this.title === "Social summary"
            ? this.data.colors
            : [
                "#96c6f2",
                // "#90CAF9",
                "#56a4ea",
                // "#42A5F5",
                "#1a81df",
                // "#1976D2",
                "#135c9f",
                // "#0D47A1",
                "#0f4a7f",
                // "#90CAF9",
                "#07253f",
                "#00116b",
                // "#90CAF9",
                "#0011db2",
                // "#42A5F5",
                "#0029f9",
                // "#1976D2",
                "#4261ff",
                // "#0D47A1",
                "#899dff",
                // "#90CAF9",
                "#74b8f0",
              ],
        title: {
          text: this.title,
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
          stackLabels: {
            enabled: true,
          },
        },
        tooltip: {
          headerFormat: "",
          pointFormat: "{series.name}: {point.y} ครั้ง",
        },

        plotOptions: {
          column: {
            stacking: this.data.stacking,
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            shadow: false,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                var pcnt = (this.y / dataSum) * 100;
                let percent = Highcharts.numberFormat(pcnt);
                return `${parseFloat(percent).toFixed(1)} %`;
              },
            },
          },
        },
        series: x,
      };
      return chart;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>